import React from "react";
import { Box, Skeleton, Paper, Stack } from "@mui/material";
import PageContainer from "./PageContainer";
import PageSection from "./PageSection";

const DriveSkeleton: React.FC = () => {
  return (
    <PageContainer sx={{ display: "flex", flexDirection: "column", mt: 2 }}>
      {/* Search Section Skeleton */}
      <Box sx={{ mb: 2.5 }}>
        <Skeleton
          variant="rectangular"
          width="100%"
          height={48}
          sx={{ borderRadius: 2 }}
        />
      </Box>

      {/* Filter Section Skeleton */}
      <Box sx={{ mb: 1.5 }}>
        <Stack
          direction="row"
          spacing={1.5}
          sx={{ flexWrap: "wrap", gap: 1.5 }}
        >
          <Skeleton
            variant="rectangular"
            width={120}
            height={36}
            sx={{ borderRadius: 1 }}
          />
        </Stack>
      </Box>

      {/* Drive Items Grid Skeleton */}
      <PageSection>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              sm: "repeat(2, 1fr)",
              md: "repeat(4, 1fr)",
              lg: "repeat(5, 1fr)",
              xl: "repeat(6, 1fr)",
            },
            gap: 1.5,
          }}
        >
          {Array.from({ length: 12 }).map((_, index) => (
            <Paper
              key={index}
              elevation={0}
              sx={{
                border: "1px solid",
                borderColor: "divider",
                borderRadius: 2,
                overflow: "hidden",
                display: "flex",
                flexDirection: "column",
              }}
            >
              {/* Image/Icon Area Skeleton */}
              <Skeleton
                variant="rectangular"
                width="100%"
                height={120}
                sx={{ borderRadius: 0 }}
              />

              {/* Content Area Skeleton */}
              <Box sx={{ p: 1.5, flexGrow: 1, display: "flex", flexDirection: "column" }}>
                <Skeleton
                  variant="text"
                  width="90%"
                  height={20}
                  sx={{ mb: 0.5 }}
                />
                <Skeleton
                  variant="text"
                  width="60%"
                  height={16}
                  sx={{ mb: 0.75 }}
                />
                <Skeleton
                  variant="rectangular"
                  width={80}
                  height={18}
                  sx={{ borderRadius: 1 }}
                />
              </Box>

              {/* Actions Area Skeleton */}
              <Box
                sx={{
                  p: 1,
                  display: "flex",
                  gap: 1,
                  justifyContent: "flex-end",
                  borderTop: "1px solid",
                  borderColor: "divider",
                }}
              >
                <Skeleton variant="circular" width={32} height={32} />
                <Skeleton variant="circular" width={32} height={32} />
              </Box>
            </Paper>
          ))}
        </Box>
      </PageSection>
    </PageContainer>
  );
};

export default DriveSkeleton;

